
import Vue from 'vue'
import JcdcExportWrapper from '@/components/jcdc/JcdcExportWrapper.vue'

export default Vue.extend({
  name: 'JcdcExportPrintPage',
  components: { JcdcExportWrapper },
  props: {
    align: { type: String, default: 'left' },
    secondary: { type: Boolean, default: false },
    iconOnly: { type: Boolean, default: false },
    // File Name
    appTitle: { type: String, required: true },
    title: { type: String, required: true },
    tabTitle: { type: String, default: 'Report' },
    searchList: { type: Array as () => string[], default: (): [] => [] },
    filterList: { type: Array as () => string[], default: (): [] => [] },
    infoDate: { type: [String, Date, Number, Object], default: null },
  },
  methods: {
    printPage(fileName) {
      const tempTitle = document.title
      document.title = fileName
      this.$emit('click', true)
      setTimeout(() => {
        window.print()
        document.title = tempTitle
        this.$emit('complete', true)
      }, 300)
    },
  },
})
